import React from 'react';
import BasketballComp from './Basketball.component';

class Basketball extends React.Component {
    componentDidMount() {
        BasketballComp();
    }
    render() {
        return (
            <div>
            </div>
        )
    }
}

export default Basketball;